import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BarChart3, LogIn, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GerenteLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/superadmin/login`, form);
      const { access_token, sa_role, username } = res.data;

      if (sa_role !== 'control_ventas') {
        toast.error('Este acceso es solo para Control de Ventas');
        setLoading(false);
        return;
      }

      sessionStorage.setItem('nc_superadmin_token', btoa(encodeURIComponent(access_token)));
      sessionStorage.setItem('nc_superadmin_role', sa_role);
      toast.success(`Bienvenido, ${username}`);
      navigate('/superadmin');
    } catch {
      toast.error('Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #e0f2fe 100%)' }}>
      <div className="bg-white p-8 rounded-2xl shadow-lg max-w-sm w-full mx-4">
        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center" style={{ background: 'var(--accent-wash)' }}>
            <BarChart3 size={32} className="text-accent-text" />
          </div>
          <h1 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>Control de Ventas</h1>
          <p className="text-sm text-text-muted mt-1">Panel de monitoreo de negocios</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="gerente-login-form">
          <div>
            <label className="block text-sm font-medium mb-1">Usuario</label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 text-sm"
              style={{ borderColor: 'var(--border-light)' }}
              placeholder="Tu usuario"
              data-testid="gerente-username"
              required autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 text-sm pr-10"
                style={{ borderColor: 'var(--border-light)' }}
                placeholder="Tu contraseña"
                data-testid="gerente-password"
                required
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-primary">
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full py-3 rounded-xl text-white font-medium text-sm transition-all disabled:opacity-60"
            style={{ background: 'var(--accent-primary)' }}
            data-testid="gerente-submit"
          >
            {loading ? 'Ingresando...' : <><LogIn size={18} className="inline mr-2" />Ingresar</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GerenteLogin;
